// import Vue from 'vue';
import { createRouter, createWebHashHistory } from 'vue-router'
import AppPageByABC from './components/AppPageByABC.vue';
import AppPageSchedule from './components/AppPageSchedule.vue';
import AppPageByComp from './components/AppPageByComp.vue';

/*global wpData:true*/
/*eslint no-undef: "error"*/
const appPath = `/${wpData.app_path}`;

// Vue.use( Router );

/**
 * Each route should map to a component.
 * The "component" can either be an actual component or just a component options object.
 */
export default createRouter({
// 	mode: 'hash', // or "history"
	history: createWebHashHistory(appPath),
	routes: [
		{
			path: '/by-competition',
			name: 'by-competition',
			component: AppPageByComp
		},
		{
			path: '/schedule',
			name: 'schedule',
			component: AppPageSchedule
		},
		{
			path: '/by-abc',
			name: 'by-abc',
			component: AppPageByABC
		},
		{
			path: '/:pathMatch(.*)*',
			redirect: { name: 'by-abc' }
		}
	]
});

/*
 * Note: Turning on the HTML5 History Mode with "mode: 'history'" will eliminate the '#' in the URLs. However, as we're loading Vue on a Custom Page Template, the main routing is still handled by WordPress. As a result a page refresh of directly loading a Vue specific link will return 404 Not Found.
 * With the '#' in the URL the Vue specific link will work as regular link.
 * e.g.
 * http://wpvue.test/search-page/#/videos will work directly or even on page refresh but
 * http://wpvue.test/search-page/videos will not as WordPress will try to look for it.
 */
